import { inject as l, onBeforeMount as a } from "vue";
import { useSsrAdapter as d } from "./ghl-ui.es749.js";
import { configProviderInjectionKey as m } from "./ghl-ui.es949.js";
import u from "./ghl-ui.es1391.js";
import { cssrAnchorMetaName as s } from "./ghl-ui.es1314.js";
import { throwError as c } from "./ghl-ui.es853.js";
function S(t, i, f) {
  if (!i) {
    process.env.NODE_ENV !== "production" && c("use-style", "No style is specified.");
    return;
  }
  const o = d(), r = l(m, null), n = () => {
    const e = f.value;
    i.mount({
      id: e === void 0 ? t : e + t,
      head: !0,
      anchorMetaName: s,
      props: {
        bPrefix: e ? `.${e}-` : void 0
      },
      ssr: o
    }), r != null && r.preflightStyleDisabled || u.mount({
      id: "n-global",
      head: !0,
      anchorMetaName: s,
      ssr: o
    });
  };
  o ? n() : a(n);
}
export {
  S as default
};
